(function () {
    'use strict';

    angular
        .module('blocks.smart')
        .directive('smartDate', smartDate);

    /* @ngInject */
    function smartDate(moment) {
        // allows us to have a date filter on smart tables.
        // Usage:
        //  <smart-date predicate="someDateField"></smart-select>
        // Creates:
        //  <smart-select predicate="someDateField">
        //  <input><input>
        //  </smart-select>
        var directive = {
            link: link,
            require: '^stTable',
            scope: {
                options: '=',
                predicate: '@'
            },
            templateUrl: 'app/blocks/smart-table-controls/templates/smart-date.html'
        };
        return directive;

        function link(scope, element, attr, table) {
            var defaultDateOptions = {
                singleDatePicker: false,
                showDropdowns: false,
                opens: 'right',
                drops: 'down',
                alwaysShowCalendars: true,
                showCustomRangeLabel: false,
                timePicker: true,
                timePickerIncrement: 30,
                ranges: {
                    'Last 7 Days': [
                        moment().subtract(1, 'weeks'),
                        moment()
                    ],
                    'Last 30 Days': [
                        moment().subtract(1, 'months'),
                        moment()
                    ]
                },
                locale: {
                    format: 'MM/DD/YYYY h:mm A'
                }
            };

            var inputs = element.find('input');
            var input = angular.element(inputs[0]);

            var predicateName = attr.predicate;
            
            function runSearch() {
                if (!!scope.searchDate) {
                    //var query = moment(scope.searchDate).toDate();
                    var query = scope.searchDate;
                    table.search(query, predicateName);
                } else {
                    table.search('null', predicateName);
                }
            }

            function open() {
                input.data('daterangepicker').show();
            }
            
            scope.dateOptions = (scope.options === undefined) ? defaultDateOptions : scope.options;
            // apply all event handlers to date component here
            scope.dateOptions.eventHandlers = { 'apply.daterangepicker': applyDate };
            
            scope.searchDate = moment();
            scope.dateRange = {startDate: null, endDate: null};
            scope.open = open;
           
            scope.$watch(
               function watch(scope) {
                   return (table.tableState().search.predicateObject &&
                       table.tableState().search.predicateObject[scope.predicate]);
               }, function (newValue) {
                   if (typeof newValue === 'undefined') {
                       scope.dateRange = { startDate: null, endDate: null };
                   }
               }, true);
            
            function applyDate(ev, picker) {
                scope.searchDate = scope.dateRange;
                runSearch();
            }
        }
    }
})();
